import { ref, computed } from "vue";
import { defineStore } from "pinia";
import useMyFetch from "@stores/useMyFetch";

export const useAdAccountsStore = defineStore("adAccounts", () => {
  const adAccounts = ref([]);

  const fetchAdAccounts = async () => {
    const { data, response } = await useMyFetch(`/resources/fbadaccs`).json();
    if (response.value.ok) {
      adAccounts.value = data.value;
    }
  };

  const adAccountOptions = computed(() => {
    return adAccounts.value.map((a) => ({ label: a.name, value: a.id }));
  });

  return {
    adAccounts,
    fetchAdAccounts,
    adAccountOptions,
  };
});
